import * as React from "react"
import { Box, Chip, Grid, Typography } from "@mui/material"
import { formatNumber, formatPrice } from "@ui-seeker/utils"

import { HierarchicalTextBlock, IconDetails, RatingStars } from "@components"


export default function AdminScrapingDataReviewDetailsDrawerContentTabFeatures(props) {
    const {
        stockOnline, externalSeller, clickAndCollect, freeShipping, gifts, shippingPrice, currency, eyecatchs=[], rating, numOpinions, lastReviewRating, lastReviewTitle, lastReview
    } = props
    const haveEyecatchs = eyecatchs.length > 0

    return <Box display="flex" flexDirection="column" gap={2}>
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Box display="flex" gap={1}>
                <IconDetails icon={stockOnline ? "store" : "store-alt-slash"} value={stockOnline} tooltip="Stock" />
                <IconDetails icon={externalSeller ? "person-dolly" : "person-dolly-empty"} value={externalSeller} tooltip="External Seller" />
                <IconDetails icon="mouse" value={clickAndCollect} tooltip="Click & Collect" />
                <IconDetails icon="shipping-fast" value={freeShipping} tooltip="Free Shipping" />
                <IconDetails icon="gift" value={gifts} tooltip="Gifts" />
            </Box>

            <Typography variant="subtitle1">
                { !!shippingPrice && formatPrice(shippingPrice, currency) }
            </Typography>
        </Grid>

        <Grid item xs={12} sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Typography variant="subtitle2" sx={{ pt: .2 }}>
                Eyecatchs:
            </Typography>
            { haveEyecatchs ? eyecatchs.map((item, idx) => <Chip key={idx} label={item} />) : "--" }
        </Grid>

        <Grid item xs={12} sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Typography variant="subtitle2" sx={{ pt: .3 }}>
                Rating:
            </Typography>
            <RatingStars rating={rating} />
            <Typography variant="overline">
                ({formatNumber(rating, { decimals: 1 })})
            </Typography>
        </Grid>

        { !!numOpinions && <Grid item xs={12} sx={{ display: "flex", flexDirection: "column", gap: .5 }}>
            <Typography variant="subtitle1">
                1 to {numOpinions} Reviews
            </Typography>
            <Typography variant="subtitle2">
                Last Review
            </Typography>
            <HierarchicalTextBlock
                supertitle="Rating: "
                supertitleValue={lastReviewRating ? formatNumber(lastReviewRating, { decimals: 1 }) : "--"}
                title="Title: "
                titleValue={lastReviewTitle || "--"}
                subtitle=""
                subtitleValue={lastReview || ""}
            />
        </Grid>}
    </Box>
}